import { useEffect, useState } from "react";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";
import { toast } from "react-toastify";
import AddBlogModal from "./AddBlogModal";
import UpdateBlogModal from "./UpdateBlogModal"; // Changed from EditCategoryModal to UpdateBlogModal

export default function BlogTable() {
  const [showAddBlog, setShowAddBlog] = useState(false);
  const [showEditBlog, setShowEditBlog] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [editableBlog, setEditableBlog] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const toggleAddBlog = () => {
    setShowAddBlog(!showAddBlog);
  };

  const toggleEditBlog = (blog) => {
    setEditableBlog(blog);
    setShowEditBlog(!showEditBlog);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleDeleteBlog = async (blogId) => {
    if (window.confirm("Are you sure you want to delete this blog?")) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/blogs/delete-blog/${blogId}`,
          { method: "DELETE" }
        );
        if (!response.ok) throw new Error("Failed to delete the blog.");
        toast.success("Blog deleted successfully!");
        fetchBlogs();
      } catch (error) {
        console.error("Delete error:", error);
        toast.error("Error deleting the blog.");
      }
    }
  };

  const fetchBlogs = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/blogs/all-blogs`
      );

      if (!response.ok) throw new Error("Failed to fetch blogs.");
      const data = await response.json();

      setBlogs(data.allBlogs);
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Error fetching blogs.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-800">Blog & News</h1>
        <button
          className="hover:bg-primary-dark flex items-center rounded-md bg-primary px-4 py-2 text-primaryText transition-colors"
          onClick={toggleAddBlog}
        >
          <MdAdd className="mr-2" size={20} />
          Add Blog & News
        </button>
      </div>

      {showAddBlog && (
        <AddBlogModal
          toggleAddCategory={toggleAddBlog}
          showAddCategory={showAddBlog}
          onBlogAdded={fetchBlogs}
        />
      )}

      {showEditBlog && editableBlog && (
        <UpdateBlogModal
          blogId={editableBlog.id} // Changed from categoryId to blogId
          toggleModal={() => toggleEditBlog(null)}
          showModal={showEditBlog}
          onBlogUpdated={fetchBlogs}
        />
      )}

      {/* Blog Table */}
      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-primary">
            <tr>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-primaryText"
              >
                Image
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-primaryText"
              >
                Title
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-primaryText"
              >
                Link
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider text-white"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {isLoading ? (
              <tr>
                <td colSpan="2" className="px-6 py-4 text-center">
                  <div className="flex justify-center">
                    <div className="border-t-transparent h-8 w-8 animate-spin rounded-full border-4 border-primary"></div>
                  </div>
                </td>
              </tr>
            ) : blogs.length === 0 ? (
              <tr>
                <td colSpan="2" className="px-6 py-4 text-center text-gray-500">
                  No blogs found. Add your first blog!
                </td>
              </tr>
            ) : (
              blogs.map((blog) => (
                <tr key={blog.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">
                    <img
                      src={`${process.env.REACT_APP_API_URL_Plain}/config/uploads/blogs/${blog.image}`}
                      alt="Blog"
                      className="h-10 w-10 object-cover"
                    />
                  </td>
                  <td className="whitespace-nowrap px-6 py-4">
                    <div className="flex items-center">
                      <div className="text-base font-medium text-gray-900">
                        {blog.title}
                      </div>
                    </div>
                  </td>
                  <td className="whitespace-nowrap px-6 py-4">
                    <div className="flex items-center">
                      <div className="text-base font-medium text-gray-900">
                        {blog.link}
                      </div>
                    </div>
                  </td>
                  <td className="whitespace-nowrap px-6 py-4 text-right text-sm font-medium">
                    <div className="flex justify-end space-x-2">
                      <button
                        onClick={() => toggleEditBlog(blog)}
                        className="rounded-md p-2 text-gray-600 transition-colors hover:bg-gray-100 hover:text-primary"
                        title="Edit"
                      >
                        <MdEdit size={18} />
                      </button>
                      <button
                        onClick={() => handleDeleteBlog(blog.id)} // Changed from handleDeleteCategory to handleDeleteBlog
                        className="rounded-md p-2 text-gray-600 transition-colors hover:bg-gray-100 hover:text-red-600"
                        title="Delete"
                      >
                        <MdDelete size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
